import React from "react";

import { RegisterEmailCaptureLeadsWrapper } from "@components/BuilderWrapperComponents/EmailCaptureLeadsWrapper";
import { RegisterSocialLinksWrapper } from "@components/BuilderWrapperComponents/SocialLinksWrapper";
import FooterNavigationSection from "../FooterNavigationSection";

type FooterNavigationEssentialType = {
  pathname: string;
};

const FooterNavigationMain: React.FC<FooterNavigationEssentialType> = ({
  pathname,
}) => (
  <FooterNavigationSection pathname={pathname} model="footer-navigation-main" />
);

export default FooterNavigationMain;

RegisterEmailCaptureLeadsWrapper();
RegisterSocialLinksWrapper();
